import autoBind from 'react-autobind'
import React from 'react';
// import Link from 'react-router-dom/Link';
import { StyleSheet, css } from 'aphrodite-jss';


class CookiesPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      display:true,
      delay:true,
    };
    autoBind(this);
  }

  
  hide(){
    this.setState({display:false});
    setTimeout(() => this.setState({ delay: false}), 600);
    document.cookie = "agree=yes";
  }
  componentDidMount(){
    if(document.cookie.replace(/(?:(?:^|.*;\s*)agree\s*\=\s*([^;]*).*$)|^.*$/, "$1") == "yes"){
      this.setState({ delay: false});
    }
  }


  render() {
  const displayState = this.state.display ? styles.displayON : styles.displayOFF;
    const displayOFFState = this.state.delay ? null : styles.displayOFFOFF;
    
    return (
      <div className={css(styles.wrapper, displayState, displayOFFState)}>
        <div>By using this website you agree to our privacy policy</div>
        <a href="../images/Tushek_privacy_policy.pdf" target="_blank" className={css(styles.button)}>more about our policy</a>
        <img alt="close" onClick={this.hide} className={css(styles.close)} src="../assets/icons/close.png" />
      </div>
    );
  }
}


const styles = StyleSheet.create({
  wrapper:{
    margin:"0 auto",
    width:"100%",
    position:"fixed",
    bottom:0,
    color:"#000",
    display:"flex",
    textAlign:"center",
    justifyContent:"center",
    alignItems:"center",
    background:"#FBBC01",
    left:0,
    height:65,
    transition:"0.5s",
    '@media (max-width: 780px)': {
      height:80,
      flexDirection:"column",
      paddingLeft:60,
      paddingRight:60,
      width:"100%",
    },
    '@media (max-width: 540px)': { 
      height:100,
    },
    '@media (max-width: 350px)': { 
      fontSize:14,
    },
  },
  displayON:{
    opacity:1,
  },
  displayOFF:{
    opacity:0,
  },
  displayOFFOFF:{
    display:"none",
  },
  button:{
    backgroundColor: "",
    borderBottom: "#000 2px solid",
    padding: "2 2",
    color: "#000",
    textDecoration:"none",
    marginLeft:30,
    position: "relative",
    transition: "all .2s",
    cursor:"pointer",
    '@media (max-width: 780px)': {
      marginLeft:0,
      marginTop:7,
    },
  },
  close:{
    position:"fixed",
    width:20,
    bottom:22,
    right:30,
    cursor:"pointer",
    zIndex:1000,
    '@media (max-width: 780px)': {
      bottom:29,
      right:20,
    },
    '@media (max-width: 540px)': { 
      bottom:39,
    },
  },
  
});

export default CookiesPopup;



// WEBPACK FOOTER //
// ./src/components/CookiesPopup.js